import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type LoadingPageMessages = {
  title: string;
  subtitle?: string;
  descriptions?: string[];
};

export type NavigationState = {
  a11yMessage: string;
  loadingPage: {
    isVisible: boolean;
    messages?: LoadingPageMessages;
  };
};

type A11yNavigationPayload = {
  a11yMessage: string;
};

type LoadingPageNavigationPayload = {
  messages?: LoadingPageMessages;
  isVisible: boolean;
};

type ActionsType = {
  setA11yMessage: (state: NavigationState, { payload }: PayloadAction<A11yNavigationPayload>) => void;
  setLoadingPage: (state: NavigationState, { payload }: PayloadAction<LoadingPageNavigationPayload>) => void;
};

const defaultState = {
  a11yMessage: '',
  loadingPage: {
    isVisible: false,
  },
};

export const navigationSlice = createSlice<NavigationState, ActionsType>({
  name: 'navigation',
  initialState: defaultState,
  reducers: {
    setA11yMessage(state: NavigationState, { payload }: PayloadAction<A11yNavigationPayload>) {
      state.a11yMessage = payload.a11yMessage;
    },
    setLoadingPage(state: NavigationState, { payload }: PayloadAction<LoadingPageNavigationPayload>) {
      state.loadingPage = payload;
    },
  },
});
